import type { ReactNode } from "react";
import { IconArrowRight } from "./Icons";

type PillarCardProps = {
  icon: ReactNode;
  title: string;
  description: string;
  linkText?: string;
  active?: boolean;
  onClick?: () => void;
};

export const PillarCard = ({
  icon,
  title,
  description,
  linkText,
  active = false,
  onClick,
}: PillarCardProps) => {
  const classes = ["sg-pillar-card", active ? "is-active" : ""]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
      aria-pressed={active}
    >
      <span className="sg-pillar-card__icon">{icon}</span>
      <h3 className="sg-pillar-card__title">{title}</h3>
      <p className="sg-pillar-card__description">{description}</p>
      {linkText ? (
        <span className="sg-pillar-card__link">
          {linkText} <IconArrowRight size={16} />
        </span>
      ) : null}
    </button>
  );
};
